import { motion } from 'motion/react'
import { BarChart3, FileCheck, LineChart, Settings2 } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

const features = [
  {
    icon: BarChart3,
    title: 'One-Click PRISMA',
    description:
      'Generate perfect PRISMA flowcharts instantly. No more manual diagrams or formatting headaches.',
  },
  {
    icon: Settings2,
    title: 'Fits Your Process',
    description:
      'Adapts to your SOPs, not the other way around. Custom workflows that match your needs exactly.',
  },
  {
    icon: FileCheck,
    title: 'Built-in Compliance',
    description:
      'Every feature designed for MDR compliance. Pass audits with confidence every time.',
  },
  {
    icon: LineChart,
    title: 'Real-time Insights',
    description: 'Track progress, spot trends, and make decisions faster with automated analytics.',
  },
]

export const FeaturesSection = () => (
  <section className="relative bg-white py-24">
    {/* Subtle texture background */}
    <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?ixlib=rb-4.0.3')] opacity-[0.02] mix-blend-soft-light"></div>

    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-16 text-center"
      >
        <h2 className="mb-4 text-4xl font-bold text-[#001871] md:text-5xl">
          Everything You Need, Nothing You Don't
        </h2>
        <p className="text-xl text-gray-600">
          Purpose-built for medical device teams, with features that actually make your life easier.
        </p>
      </motion.div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {features.map((feature, index) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <Card className="border border-gray-100 bg-white transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-xl bg-[#001871]/5 p-4">
                    <feature.icon className="size-10 text-[#001871]" />
                  </div>
                  <h3 className="mb-2 text-xl font-semibold text-[#001871]">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
)
